<div class="bg-muted/40 overflow-hidden rounded-lg border">
  <div class="flex items-center justify-between gap-2 border-b px-3 py-2">
    <span class="text-muted-foreground text-xs font-medium tracking-wide uppercase">
      {{ title() }}
    </span>
    <button hlmBtn type="button" variant="outline" size="sm" (click)="copy()">
      <ng-icon [name]="copyState() === 'copied' ? 'lucideCheck' : 'lucideCopy'" />
      {{ copyState() === 'copied' ? 'Kopiert' : 'Code kopieren' }}
    </button>
  </div>

  <!-- Line numbers are presentation only: screen readers and text selection get the code alone -->
  <pre
    class="overflow-x-auto py-3 font-mono text-xs leading-relaxed"
    tabindex="0"
    [attr.aria-label]="
      title()
    "><code class="grid grid-cols-[auto_1fr]">@for (line of lines(); track $index) {<span class="text-muted-foreground/60 select-none pe-4 ps-3 text-end tabular-nums" aria-hidden="true">{{ $index + 1 }}</span><span class="min-h-[1lh] pe-4">@for (token of line; track $index) {<span [class]="tokenClasses[token.kind]">{{ token.text }}</span>}{{ '\n' }}</span>}</code></pre>

  <ng-content />

  <p class="sr-only" role="status">
    @switch (copyState()) {
      @case ('copied') {
        Code in die Zwischenablage kopiert
      }
      @case ('failed') {
        Kopieren nicht möglich
      }
    }
  </p>
  @if (copyState() === 'failed') {
    <p class="text-destructive border-t px-3 py-2 text-xs">
      Kopieren hat nicht geklappt. Markiere den Code und kopiere ihn mit Strg+C bzw. ⌘+C.
    </p>
  }
</div>
